(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["band-types"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('band-type').addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex];
    const size = selectedOption.getAttribute('data-size');
    const collection = selectedOption.getAttribute('data-collection');

    if (size && collection) {
      document.getElementById('collection-url').style.display = 'block';
      document.getElementById('watch-size').innerText = size;
      document.getElementById('collection-url').setAttribute('href', collection);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-watches-hero"] && !Shopify.designMode) return;
  try {
    
  function getHeaderOffset() {
    var headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');
    var totalHeaderOffset = Array.from(headerGroupSections).reduce(function (total, el) {
      return total + el.offsetHeight;
    }, 0);

    return totalHeaderOffset + 16;
  }

  function smoothScrollToHash(hash) {
    if (!hash || hash === '#') return false;

    var target = document.querySelector(hash);
    if (!target) return false;

    var title = target.querySelector('.multicolumn-head, h1, h2, h3');
    var scrollTarget = title || target;
    var scrollTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(scrollTop, 0),
      behavior: 'smooth',
    });

    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-custom-watches-smooth-scroll]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    if (smoothScrollToHash(href)) {
      event.preventDefault();
      history.pushState(null, '', href);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    let getProdHandles = JSON.parse(localStorage.getItem('product_handles')) || [];

    function isNullOrUndefined(value) {
      return value === undefined || value === null;
    }

    function formatPrice(amount, currencyCode) {
      const locale = window.Shopify.locale || 'en-US'; // Default to 'en-US' if locale is not set
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
      }).format(amount);
    }

    function appendProductRating(response) {
        let productRating = response.data.product.productRating?.value;
        let ratingDecimal = 0;
        let convertDec = productRating % 1;
        let decimal = convertDec.toFixed(1);

        if (decimal >= 0.3 && decimal <= 0.7) {
            ratingDecimal = 0.5;
        } else if (decimal > 0.7) {
            ratingDecimal = 1;
        }

        let finalRating = Math.floor(productRating) + ratingDecimal;

        var ratingAria =
          (window.accessibilityStrings?.starReviewsInfoPattern || '[rating_value] out of [rating_max] stars')
            .replace('[rating_value]', productRating)
            .replace('[rating_max]', '5');
        var productHtml = `<td class='${response.data.product.productRating?.value}'><span class="rating-number">${response.data.product.productRating?.value}</span><div class="rating" role="img" aria-label="${ratingAria}">
                    <span aria-hidden="true" class="rating-star" style="--rating: ${parseInt(finalRating)}; --rating-max: 5; --rating-decimal: ${ratingDecimal};"></span>
                  </div></td>`;
        document.querySelector('.product-rating').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.product-rating td').length;
          var countUndefined = $('.product-rating td.undefined').length;
          if (countUndefined == countTd) {
            $('.product-rating').addClass('no-row');
          }
        }, 2300);
    }

    function appendWaterRating(response) {
        var productHtml = `<td class='${response.data.product.waterRating?.value}'><span>${response.data.product.waterRating?.value}</span></td>`;
        document.querySelector('.water-rating').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.water-rating td').length;
          var countUndefined = $('.water-rating td.undefined').length;
          if (countUndefined == countTd) {
            $('.water-rating').addClass('no-row');
          }
        }, 2300);
    }

    function appendWatchCrystalMaterial(response) {
        var productHtml = `<td class='${response.data.product.watchCrystalMaterial?.value}'><span>${response.data.product.watchCrystalMaterial?.value}</span></td>`;
        document.querySelector('.watchCrystalMaterial').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.watchCrystalMaterial td').length;
          var countUndefined = $('.watchCrystalMaterial td.undefined').length;
          if (countUndefined == countTd) {
            $('.watchCrystalMaterial').addClass('no-row');
          }
        }, 2300);
    }

    function appendWatchSize(response) {      
        var productHtml = `<td class='${response.data.product.watchSize?.value}'><span>${response.data.product.watchSize?.value}</span></td>`;
        document.querySelector('.watchSize').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.watchSize td').length;
          var countUndefined = $('.watchSize td.undefined').length;
          if (countUndefined == countTd) {
            $('.watchSize').addClass('no-row');
          }
        }, 2300);
    }

    function appendWatchCaseThickness(response) {
        var productHtml = `<td class='${response.data.product.watch_case_thickness_mm?.value}'><span>${response.data.product.watch_case_thickness_mm?.value}</span></td>`;
        document.querySelector('.watch_case_thickness_mm').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.watch_case_thickness_mm td').length;
          var countUndefined = $('.watch_case_thickness_mm td.undefined').length;
          if (countUndefined == countTd) {
            $('.watch_case_thickness_mm').addClass('no-row');
          }
        }, 2300);
    }

    function appendWatchMovementText(response) {
        var productHtml = `<td class='${response.data.product.watchMovement?.value}'><span>${response.data.product.watchMovement?.value}</span></td>`;
        document.querySelector('.watchMovement').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.watchMovement td').length;
          var countUndefined = $('.watchMovement td.undefined').length;
          if (countUndefined == countTd) {
            $('.watchMovement').addClass('no-row');
          }
        }, 2300);
    }

    function appendLugMeasurement(response) {
        var productHtml = `<td class='${response.data.product.lug_measurement_mm?.value}'><span>${response.data.product.lug_measurement_mm?.value}</span></td>`;
        document.querySelector('.lug_measurement_mm').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.lug_measurement_mm td').length;
          var countUndefined = $('.lug_measurement_mm td.undefined').length;
          if (countUndefined == countTd) {
            $('.lug_measurement_mm').addClass('no-row');
          }
        }, 2300);
    }

    function appendBandType(response) {
        var productHtml = `<td class='${response.data.product.band_type?.value}'><span>${response.data.product.band_type?.value}</span></td>`;
        document.querySelector('.band_type').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.band_type td').length;
          var countUndefined = $('.band_type td.undefined').length;
          if (countUndefined == countTd) {
            $('.band_type').addClass('no-row');
          }
        }, 2300);
    }

    function appendBandConnection(response) {
        var productHtml = `<td class='${response.data.product.band_connection?.value}'>${response.data.product.band_connection?.value}</td>`;
        document.querySelector('.band_connection').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.band_connection td').length;
          var countUndefined = $('.band_connection td.undefined').length;
          if (countUndefined == countTd) {
            $('.band_connection').addClass('no-row');
          }
        }, 2300);
    }

    function appendBandMaterial(response) {
        var productHtml = `<td class='${response.data.product.band_material?.value}'>${response.data.product.band_material?.value}</td>`;
        document.querySelector('.band_material').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.band_material td').length;
          var countUndefined = $('.band_material td.undefined').length;
          if (countUndefined == countTd) {
            $('.band_material').addClass('no-row');
          }
        }, 2300);
    }

    function appendWarranty(response) {
        var productHtml = `<td class='${response.data.product.warranty?.value}'>${response.data.product.warranty?.value}</td>`;
        document.querySelector('.warranty').insertAdjacentHTML('beforeend', productHtml);
        setTimeout(function () {
          var countTd = $('.warranty td').length;
          var countUndefined = $('.warranty td.undefined').length;
          if (countUndefined == countTd) {
            $('.warranty').addClass('no-row');
          }
        }, 2300);
    }

    function apiCall(value) {
      return fetch(`${window.Shopify.routes.root}api/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/graphql',
          'Access-Control-Allow-Origin': '*',
          'X-Shopify-Storefront-Access-Token': window.compareAppToken,
        },
        body: `query {
        shop {
          moneyFormat
        }
        product(handle: "${value}") {
          title
          handle
          images(first: 1) {
            edges {
              node {
                id
                url
              }
            }
          }
          compareAtPriceRange {
              minVariantPrice {
                amount
                currencyCode
              }
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          productRating: metafield(namespace: "turnto", key: "product_rating") {
            value
          }
          watch_case_thickness_mm: metafield(namespace: "specifications", key: "watch_case_thickness_mm") {
            value
          }
          watchMovement: metafield(namespace: "specifications", key: "watch_movement_type") {
            value
          }
          watchSize: metafield(namespace: "specifications", key: "watch_size_mm") {
            value
          }
          watchCrystalMaterial: metafield(namespace: "specifications", key: "watch_crystal_material") {
            value
          }
          waterRating: metafield(namespace: "specifications", key: "watch_water_rating") {
            value
          }
          lug_measurement_mm: metafield(namespace: "specifications", key: "lug_measurement_mm") {
            value
          }
          band_type: metafield(namespace: "specifications", key: "band_type") {
            value
          }
          band_connection: metafield(namespace: "specifications", key: "band_connection") {
            value
          }
          band_material: metafield(namespace: "specifications", key: "band_material") {
            value
          }
          warranty: metafield(namespace: "specifications", key: "warranty") {
            value
          }
        }
      }`,
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      });
    }

    getProdHandles.forEach((value) => {
      apiCall(value)
        .then((response) => {
          const currencyCode = response.data.product.priceRange.minVariantPrice.currencyCode;
          const price = parseFloat(response.data.product.priceRange.minVariantPrice.amount);
          const compareAtPrice = parseFloat(response.data.product.compareAtPriceRange.minVariantPrice.amount);

          let formattedPrice = formatPrice(price, currencyCode);
          let formattedCompareAtPrice = compareAtPrice !== 0 ? formatPrice(compareAtPrice, currencyCode) : '';

          // If the currencyCode is AUD, CAD, or USD, replace the 'A$', 'CA$', etc., with just '$'
          if (currencyCode === 'AUD' || currencyCode === 'CAD' || currencyCode === 'USD') {
            formattedPrice = formattedPrice.replace(/[A-Z]{1,2}\$/, '$');
            formattedCompareAtPrice = formattedCompareAtPrice.replace(/[A-Z]{1,2}\$/, '$');
          }

          // Special handling for EUR to display the Euro symbol before the number
          if (currencyCode === 'EUR') {
            formattedPrice = '€' + formattedPrice.replace('€', '').trim();
          }

          var productHtml = `<td>
                              <a href="${window.Shopify.routes.root}products/${response.data.product.handle}"><img src="${response.data.product.images.edges[0].node.url}" alt="${response.data.product.title}" width='100' height='100' /></a>
                              <a href="${window.Shopify.routes.root}products/${response.data.product.handle}" class='prod-name'>${response.data.product.title}</a>
                              <span class='prod-price'>
                                <span class='reg-price ${compareAtPrice}'>
                                  ${formattedPrice}
                                </span>
                                <span class='compare-at'>
                                  ${formattedCompareAtPrice}
                                </span>
                              </span>
                              <a class="prod-link button" href="${window.Shopify.routes.root}products/${response.data.product.handle}">${window.variantStrings.addToCart}</a>
                            </td>`;
          document.querySelector('.main-product-header').insertAdjacentHTML('beforeend', productHtml);
          appendWatchCaseThickness(response);
          appendWatchMovementText(response);
          appendProductRating(response);
          appendWatchSize(response);          
          appendWatchCrystalMaterial(response);
          appendWaterRating(response);
          appendLugMeasurement(response);
          appendBandType(response);
          appendBandConnection(response);
          appendBandMaterial(response);
          appendWarranty(response);
          setTimeout(() => {
            document.querySelector('.compare-loading').style.display = 'none';
          }, 2500);
        })
        .catch((error) => {
          console.error('API call error:', error);
          document.querySelector('.compare-loading').style.display = 'none';
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-customer-service"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    /* Open chat with us widget */
    var chatWithUsLinks = document.querySelectorAll('a[href="#chatwithus"]');
    chatWithUsLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        fcWidget.open();
      });
    });
    /* End open chat with us widget */

    /* Scroll to the target on load */
    if (!window.matchMedia('(max-width: 1023px)').matches) return;

    var targetOnLoad = false;
    var sectionsWithLinks = document.querySelectorAll('[data-page-link]');
    sectionsWithLinks.forEach(function (section) {
      var pageLink = section.dataset.pageLink;
      if (pageLink && window.location.href.includes(pageLink)) {
        targetOnLoad = section;
      }
    });

    if (!targetOnLoad) {
      targetOnLoad = document.querySelector('.customer-service__main-header');
    }

    if (!targetOnLoad) return;

    var headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');
    var totalHeaderOffset = Array.from(headerGroupSections).reduce(function (total, el) {
      return total + el.offsetHeight;
    }, 0);

    var scrollTop = targetOnLoad.getBoundingClientRect().top + window.pageYOffset - totalHeaderOffset;

    window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    /* End scroll to the target on load */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-pages-navbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var pageNavbar = document.querySelector('.pageNavbar');
    var activeLink = pageNavbar && pageNavbar.querySelector('a.active');

    if (!activeLink) return;

    activeLink.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
